export default __webpack_public_path__ + "static/media/n7.cfff5a94.svg";